import moment from 'moment-timezone';
import { environment } from 'environments';
import { SA_AUTH_SERVICE_MAP } from '@script-assist-integration';

VisitController.$inject = [
  '$location',
  '$scope',
  '$timeout',
  '$interval',
  '$rootScope',
  '$state',
  '$log',
  '$stateParams',
  'toastr',
  'ngDialog',
  'Auth',
  'Utils',
  'Notifications',
  'Orders',
  'Services',
  'Users',
  'Constants',
  '$filter',
  'localStorageService',
  'VideoService',
  'Business',
  'GeoService',
  'Messages',
  'Tracking',
  'Batching',
  'MedicationService',
  'LoggedInUserStore',
  'snackBar',
  'RefillResponsesStoreStore',
  'Promos',
  'VisitBridgeStore',
];

function VisitController(
  $location,
  $scope,
  $timeout,
  $interval,
  $rootScope,
  $state,
  $log,
  $stateParams,
  toastr,
  ngDialog,
  Auth,
  Utils,
  Notifications,
  Orders,
  Services,
  Users,
  Constants,
  $filter,
  localStorageService,
  VideoService,
  Business,
  GeoService,
  Messages,
  Tracking,
  Batching,
  MedicationService,
  LoggedInUserStore,
  snackBar,
  RefillResponsesStoreStore,
  Promos,
  VisitBridgeStore,
) {
  'ngInject'; // We clear the Prescriptions array cache
  // Everytime we open a visit
  // Or we refresh the visit details page

  localStorageService.set('visitMedications', {});
  let self = this,
    sessionDialogOpen = false,
    sessionTimer,
    finalTimer,
    partnerLabsResult = null,
    flagPartnerLabs = false,
    newMessagesPoll,
    visitPoll,
    queuePoll,
    batchSupscription = null,
    lockPollInterval = null;

  self.paramTab = $stateParams.tab;
  self.visitId = $stateParams.id;
  self.$rootScope = $rootScope;
  ((self.timezone = $rootScope.timezones[0].timezone), (self.statsVisible = false));
  self.getShowStats = false;
  self.showReviewButton = false;
  self.showNotTreatedButtonForDR = false;
  self.showNotTreatedButtonForPST = false;
  self.review_text = null;
  self.BOD_2268_BOD_2305 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
  self.BODACDC_3966 = FEATURE_BODACDC_3966;
  self.BODACDC_5307 = FEATURE_BODACDC_5307;
  // hasUnreadMessages is passed into the patient-messages component which uses it as a boolean as well, no reason for it being initialized as a string
  self.hasUnreadMessages = self.BOD_2268_BOD_2305 ? false : 'false';
  self.promoCodeStyle = {};

  self.userProviderModalities = {};
  self.blocked_action = 'clinical';
  self.serviceHasLabs = false;
  self.timezone = $rootScope.timezones[0].timezone;
  self.timezones = $rootScope.timezones;
  self.currentUser = Auth.profile;
  self.batchAudit = [];
  self.getAgeAlertClass = getAgeAlertClass;
  self.getGenderAgeAlertClass = getGenderAgeAlertClass;
  self.queueEntryExists = queueEntryExists;
  self.showHangupModal = showHangupModal;
  self.callTokboxModal = callTokboxModal;
  self.callTokboxPhoneCallModal = callTokboxPhoneCallModal;
  self.closeAllVideoDialogs = closeAllVideoDialogs;
  self.openVideoModal = openVideoModal;
  self.openPhoneCallModal = openPhoneCallModal;
  self.openHangupModal = openHangupModal;
  self.hangupNotEndedPhoneCall = hangupNotEndedPhoneCall;
  self.isCurrentVisitPhoneCallModalOpen = isCurrentVisitPhoneCallModalOpen;
  self.isCurrentVisitVideoModalOpen = isCurrentVisitVideoModalOpen;
  self.appointmentBooking = appointmentBooking;
  self.isSlvTaskDone = isSlvTaskDone;
  self.slvCheckedOk = slvCheckedOk;
  self.removeFromBatching = removeFromBatching;
  self.updateBatchStatus = updateBatchStatus;
  self.unsubscribeFromBatchUpdates = unsubscribeFromBatchUpdates;
  self.options = [
    {
      id: '1',
      name: 'Clinical action',
      value: 'clinical',
    },
    {
      id: '2',
      name: 'PST Action',
      value: 'PST',
    },
  ];
  self.currentClinician = {};
  self.isSecondClick = false;
  self.isMessagesFetching = false;
  self.BOD_1780 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
  self.BOD_2378 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
  //TODO: Harold
  self.mockBMI = [
    {
      visit_id: 12345,
      date: '2023-10-23T00:00:00Z',
      height: 199,
      weight: 73,
      bmi: 18.43,
    },
    {
      visit_id: 12346,
      date: '2023-01-03T00:00:00Z',
      height: 182,
      weight: 85,
      bmi: 25.66,
    },
    {
      visit_id: 12347,
      date: '2023-12-01T00:00:00Z',
      height: 158,
      weight: 79,
      bmi: 31.65,
    },
    {
      visit_id: 12348,
      date: '2023-10-04T00:00:00Z',
      height: 164,
      weight: 53,
      bmi: 19.71,
    },
    {
      visit_id: 12349,
      date: '2023-12-24T00:00:00Z',
      height: 194,
      weight: 50,
      bmi: 13.29,
    },
    {
      visit_id: 12350,
      date: '2023-12-13T00:00:00Z',
      height: 152,
      weight: 90,
      bmi: 38.95,
    },
    {
      visit_id: 12351,
      date: '2023-12-15T00:00:00Z',
      height: 181,
      weight: 75,
      bmi: 22.89,
    },
    {
      visit_id: 12352,
      date: '2023-05-19T00:00:00Z',
      height: 175,
      weight: 95,
      bmi: 31.02,
    },
    {
      visit_id: 12353,
      date: '2023-04-20T00:00:00Z',
      height: 194,
      weight: 70,
      bmi: 18.6,
    },
    {
      visit_id: 12354,
      date: '2023-06-07T00:00:00Z',
      height: 191,
      weight: 92,
      bmi: 25.22,
    },
    {
      visit_id: 12355,
      date: '2023-11-18T00:00:00Z',
      height: 181,
      weight: 64,
      bmi: 19.54,
    },
    {
      visit_id: 12356,
      date: '2023-06-06T00:00:00Z',
      height: 194,
      weight: 90,
      bmi: 23.91,
    },
    {
      visit_id: 12357,
      date: '2023-08-27T00:00:00Z',
      height: 167,
      weight: 95,
      bmi: 34.06,
    },
    {
      visit_id: 12358,
      date: '2023-05-07T00:00:00Z',
      height: 162,
      weight: 54,
      bmi: 20.58,
    },
    {
      visit_id: 12359,
      date: '2023-11-23T00:00:00Z',
      height: 199,
      weight: 66,
      bmi: 16.67,
    },
    {
      visit_id: 12360,
      date: '2023-07-20T00:00:00Z',
      height: 169,
      weight: 60,
      bmi: 21.01,
    },
    {
      visit_id: 12361,
      date: '2023-01-28T00:00:00Z',
      height: 167,
      weight: 97,
      bmi: 34.78,
    },
    {
      visit_id: 12362,
      date: '2023-06-20T00:00:00Z',
      height: 184,
      weight: 99,
      bmi: 29.24,
    },
    {
      visit_id: 12363,
      date: '2023-08-02T00:00:00Z',
      height: 159,
      weight: 87,
      bmi: 34.41,
    },
    {
      visit_id: 12364,
      date: '2023-11-30T00:00:00Z',
      height: 163,
      weight: 67,
      bmi: 25.22,
    },
  ];
  self.BOD_2205 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
  self.LMNUK_1234 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV); //New ticket is BOD_608...
  self.BOD_1857 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
  self.BOD_1750 = ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV);
  self.productLabelStyle = {};

  RefillResponsesStoreStore.setVisitId(self.visitId);

  fetchCurrentClinician();
  Business.getFrontendParameters()
    .then(({ data }) => {
      if (data.tokbox_parameters) {
        //Cache Tokbox Parameters
        localStorageService.set('tokbox_parameters', data.tokbox_parameters);
        self.getShowStats = data.tokbox_parameters.getShowStats;
      }
    })
    .catch(err => {
      console.log(err);
    });
  $scope.$on('videocall:publisher-update', (event, publisherQualityStats) => {
    if (publisherQualityStats) {
      self.publisherQualityStats = publisherQualityStats;
    } else {
      self.publisherQualityStats = '';
    }
  });
  $scope.$on('videocall:subscriber-update', (event, subscriberQualityStats) => {
    if (subscriberQualityStats) {
      self.subscriberQualityStats = subscriberQualityStats;
    } else {
      self.subscriberQualityStats = '';
    }
  });
  $scope.$on('videocall:finished', () => {
    self.closeAllVideoDialogs(); // IF THERE ARE STILL VIDEOCALLS NOT ENDED FOR THE SAME VISIT
    // THEN WE NEED TO SHOW AGAIN HANG UP VIDEO BUTTON (EDGE CASE)

    assessingVideoCall(Orders.current.id);
  }); // SPRINT 117
  // IF SLV TASK IS NOT DONE, THEN KEEP POLLING
  // OTHERWISE STOP POLLING (NO NEED)

  $scope.$on('videocall:approved', () => {
    if (queuePoll) $interval.cancel(queuePoll); // WE NEED TO REFRESH VISIT AND BOOKING DATA AFTER SLV TASK IS COMPLETED

    self.bookingdata = null; // AFTER SLV TASK WAS APPROVED
    // WE NEED TO ADD A SMALL DELAY WHILE API IS REMOVING ANY EXISTING BOOKING

    $timeout(() => {
      // To refresh the visit
      // This is already running every 60 seconds
      // We also need to run this after the visit has been completed
      Orders.getOne(Orders.current.id, false) // true for is polling
        .then(({ data }) => {
          if (Orders.current && Orders.current.id === data.id) {
            // Object.assign(Orders.current, data);
            self.order = Orders.setCurrentVisit(data, Auth.profile);
          }
        })
        .catch(err => {});
      getCallBookingData(Orders.current.id, self.patient_address_timezone.timezoneUrlEncoded);
    }, 1000);
  });
  $scope.$on('booking:refresh', () => {
    getCallBookingData(Orders.current.id, self.patient_address_timezone.timezoneUrlEncoded);
  });
  $scope.$on('allergies:refresh', () => {
    getAllergies(Orders.current);
  });
  $scope.$on('payment:error', () => {
    getBlockedFlags();
  });
  $scope.$on('messages-thread:refresh', () => {
    getMessagesThread();
  });
  $scope.$on('visit:refresh', () => {
    // To refresh the visit
    // This is already running every 60 seconds
    // We also need to run this after the visit has been completed
    Orders.getOne(Orders.current.id, false) // true for is polling
      .then(({ data }) => {
        if (Orders.current && Orders.current.id === data.id) {
          // Object.assign(Orders.current, data);
          self.order = Orders.setCurrentVisit(data, Auth.profile);
        }
      })
      .catch(err => {});
  });

  function getBlockedFlags() {
    Orders.getFlagDetails(self.order.id, 'blocked').then(({ data }) => {
      const hasBlockedFlags = !!data && data.length;
      const lastFlag = hasBlockedFlags && data[data.length - 1];

      if (hasBlockedFlags) {
        self.order = {
          ...self.order,
          flags: {
            ...self.order.flags,
            blocked: hasBlockedFlags,
          },
          blocked_message: lastFlag.message,
          flagDetails: {
            ...lastFlag,
            createdLocal: new Date(lastFlag.created * 1000).toLocaleString(),
          },
        };
      }
    });
  }

  function getAllergies(order) {
    self.allergies_list = '';
    self.allergies_html = '';
    Orders.getUserAllergy(order.user.id)
      .then(({ data }) => {
        if (data.length) {
          data.forEach(allergy => {
            if (!self.allergies_list) {
              self.allergies_list = allergy.name;
              self.allergies_html = '<span>' + allergy.name + '</span>';
            } else {
              self.allergies_list += ', ' + allergy.name;
              self.allergies_html += '<br><span>' + allergy.name + '</span>';
            }
          });
          $('#allergies-info').hover(
            function () {
              $('#allergies-tooltip').addClass('showToolTip');
            },
            function () {
              $('#allergies-tooltip').removeClass('showToolTip');
            },
          );
        }
      })
      .catch(err => {})
      .finally(() => {});
  }

  function fetchCurrentClinician() {
    Users.getStaffUser(self.currentUser.id).then(({ data }) => {
      self.currentClinician = data;
    });
  }

  function getVisitTimezone(order) {
    // Default Timezone
    self.patient_address_timezone = {};
    self.patient_address_timezone.timezone = 'America/Los_Angeles';
    self.patient_address_timezone.timezoneUrlEncoded = 'America%2FLos_Angeles';
    self.patient_address_timezone.zoneAbbr = moment().tz(self.patient_address_timezone.timezone).format('z');
    self.patient_address_timezone.zoneName = moment().tz(self.patient_address_timezone.timezone).format('zz');
    /*
    let abbrs = {
      EST : 'Eastern Standard Time',
      EDT : 'Eastern Daylight Time',
      CST : 'Central Standard Time',
      CDT : 'Central Daylight Time',
      MST : 'Mountain Standard Time',
      MDT : 'Mountain Daylight Time',
      PST : 'Pacific Standard Time',
      PDT : 'Pacific Daylight Time',
      HST : 'Hawaii Standard Time',
      HDT : 'Hawaii Daylight Time',
      SST : 'Samoa Standard Time',
      AKST : 'Alaska Standard Time',
      AKDT : 'Alaska Daylight Time'
    };
    */

    GeoService.getAddress(order.user.zip)
      .then(result => {
        // console.log("geoService.getAddress: ", result);
        if (
          result &&
          result.data &&
          result.data.results[0] &&
          result.data.results[0].geometry &&
          result.data.results[0].geometry.location
        ) {
          let latlng =
            result.data.results[0].geometry.location.lat + ',' + result.data.results[0].geometry.location.lng;
          let timestamp = parseInt(Utils.getMillisecondsToDate() / 1000);
          GeoService.getTimezoneFromLatLng(latlng, timestamp)
            .then(result2 => {
              // console.log("geoService.getTimezoneFromLatLng: ", result2);
              if (result2 && result2.data && result2.data.timeZoneId) {
                self.patient_address_timezone = {};
                self.patient_address_timezone.timezone = result2.data.timeZoneId;
                self.patient_address_timezone.timezoneUrlEncoded = self.patient_address_timezone.timezone.replace(
                  '/',
                  '%2F',
                );
                self.patient_address_timezone.zoneAbbr = moment()
                  .tz(self.patient_address_timezone.timezone)
                  .format('z');
                self.patient_address_timezone.zoneName = moment()
                  .tz(self.patient_address_timezone.timezone)
                  .format('zz'); // console.log("self.patient_address_timezone: ", self.patient_address_timezone);

                getCallBookingData(order.id, self.patient_address_timezone.timezoneUrlEncoded);
              } else {
                // Using "default" timezone
                getCallBookingData(order.id, self.patient_address_timezone.timezoneUrlEncoded);
              }
            })
            .catch(err => {
              // Using "default" timezone
              getCallBookingData(order.id, self.patient_address_timezone.timezoneUrlEncoded);
            });
        } else {
          // Using "default" timezone
          getCallBookingData(order.id, self.patient_address_timezone.timezoneUrlEncoded);
        }
      })
      .catch(err => {
        // Using "default" timezone
        getCallBookingData(order.id, self.patient_address_timezone.timezoneUrlEncoded);
      });
  }

  function getCallBookingData(orderId, timezoneUrlEncoded) {
    Orders.getCallBookingByOrderId(orderId, timezoneUrlEncoded)
      .then(result => {
        self.bookingdata = result.data; // console.log("self.bookingdata: ", self.bookingdata);
      })
      .catch(err => {
        self.bookingdata = null; // console.log("Error: ", err);
      });
  }

  function appointmentBooking() {
    openAppointmentBookingModal(response => {
      if (response && response != '$closeButton') {
      } else {
        // If user closes the popup
        // Then do nothing
      }
    });
  }

  function openAppointmentBookingModal(callback) {
    return ngDialog.open({
      templateUrl: 'app/components/appointment-booking/appointment-booking.html',
      controller: 'AppointmentBookingController',
      controllerAs: 'vm',
      data: {
        order: self.order,
        bookingdata: self.bookingdata,
        patient_address_timezone: self.patient_address_timezone,
      },

      preCloseCallback(response) {
        return callback(response);
      },
    });
  } // function closeVideoDialogOtherVisits(id) {
  //   if ($rootScope.videoDialogs === undefined) $rootScope.videoDialogs = {};
  //   var orderId = id.toString();
  //   for (var key in $rootScope.videoDialogs) {
  //     if ($rootScope.videoDialogs.hasOwnProperty(key)) {
  //       if ($rootScope.videoDialogs[key] && (key != orderId) && ngDialog.isOpen($rootScope.videoDialogs[key].id)) {
  //         // Dialog is open, then we close it
  //         $rootScope.videoDialogs[key].close();
  //       }
  //     }
  //   }
  // }
  // function closeVideoDialog(id) {
  //   if ($rootScope.videoDialogs === undefined) $rootScope.videoDialogs = {};
  //   var orderId = id.toString();
  //   if ($rootScope.videoDialogs[orderId] && ngDialog.isOpen($rootScope.videoDialogs[orderId].id)) {
  //     // Dialog is open, then we close it
  //     $rootScope.videoDialogs[orderId].close();
  //   }
  // }

  function closeAllVideoDialogs() {
    if ($rootScope.videoDialogs === undefined) $rootScope.videoDialogs = {};

    for (var key in $rootScope.videoDialogs) {
      if ($rootScope.videoDialogs.hasOwnProperty(key)) {
        if ($rootScope.videoDialogs[key] && ngDialog.isOpen($rootScope.videoDialogs[key].id)) {
          // Dialog is open, then we close it
          $rootScope.videoDialogs[key].close();
        }
      }
    }
  }

  function callTokboxPhoneCallModal(id) {
    if ($rootScope.phoneCallDialogs === undefined) $rootScope.phoneCallDialogs = {};
    var orderId = id.toString();

    if ($rootScope.phoneCallDialogs[orderId] && ngDialog.isOpen($rootScope.phoneCallDialogs[orderId].id)) {
      // Dialog is already open
    } else {
      $rootScope.phoneCallDialogs[orderId] = ngDialog.open({
        templateUrl: 'app/components/tokbox/tokbox-phonecall-modal.html',
        // To make possible doctor still be able to use the screen behind
        overlay: false,
        // To not allow the user closes the modal without explicitely to have some action
        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,
        controller: 'TokboxPhoneCallController',
        controllerAs: 'tokbox',
        className: 'ngdialog-theme-default tokbox-phonecall-modal',
        data: {
          patient: self.user,
          visit: self.order,
        },
      });
    }
  }

  function callTokboxModal(id) {
    if ($rootScope.videoDialogs === undefined) $rootScope.videoDialogs = {};
    var orderId = id.toString();

    if ($rootScope.videoDialogs[orderId] && ngDialog.isOpen($rootScope.videoDialogs[orderId].id)) {
      // Dialog is already open
    } else {
      $rootScope.videoDialogs[orderId] = ngDialog.open({
        templateUrl: 'app/components/tokbox/tokbox-modal.html',
        // To make possible doctor still be able to use the screen behind
        overlay: false,
        // To not allow the user closes the modal without explicitely to have some action
        showClose: false,
        closeByEscape: false,
        closeByNavigation: false,
        closeByDocument: false,
        controller: 'TokboxController',
        controllerAs: 'tokbox',
        className: 'ngdialog-theme-default tokbox-modal',
        data: {
          patient: self.user,
          visit: self.order,
        },
      });
    }
  }

  function isCurrentVisitPhoneCallModalOpen() {
    if ($rootScope.phoneCallDialogs === undefined) $rootScope.phoneCallDialogs = {};
    var orderId = Orders.current.id.toString();

    if ($rootScope.phoneCallDialogs[orderId] && ngDialog.isOpen($rootScope.phoneCallDialogs[orderId].id)) {
      return true;
    } else {
      return false;
    }
  }

  function isCurrentVisitVideoModalOpen() {
    if ($rootScope.videoDialogs === undefined) $rootScope.videoDialogs = {};
    var orderId = Orders.current.id.toString();

    if ($rootScope.videoDialogs[orderId] && ngDialog.isOpen($rootScope.videoDialogs[orderId].id)) {
      return true;
    } else {
      return false;
    }
  }

  function openVideoModal() {
    callTokboxModal(Orders.current.id);
  }

  function openPhoneCallModal() {
    callTokboxPhoneCallModal(Orders.current.id);
  }

  function queueEntryExists() {
    if ($rootScope.queueEntryExists === undefined) $rootScope.queueEntryExists = false;
    return $rootScope.queueEntryExists;
  }

  function openHangupModal() {
    if ($rootScope.numActiveCalls === undefined) $rootScope.numActiveCalls = 0;

    if ($rootScope.numActiveCalls > 0 && $rootScope.activeCalls.length) {
      var task = Orders.current.getTask(Constants.VisitTasks.SmartLiveVideo);
      VideoService.openHangupModal(task, $rootScope.activeCalls[0], null);
    }
  }

  function showHangupModal() {
    if ($rootScope.numActiveCalls === undefined) $rootScope.numActiveCalls = 0;
    if ($rootScope.numActiveCalls > 0) return true;
    return false;
  }

  function checkHangupButtonToEndPhoneCall(orderId) {
    self.showHangupButtonForPhoneCall = false;
    Orders.getPhoneCalls(orderId)
      .then(({ data }) => {
        // console.log("Orders.getPhoneCalls()", data);
        data.forEach(phoneCall => {
          if (phoneCall.sip_call_id && !phoneCall.ended) self.showHangupButtonForPhoneCall = true;
        });
      })
      .catch(err => {
        console.log('Error getting phone call sessions for the current order (Orders.getPhoneCalls):', err);
      });
  }

  function subscribeToBatchableVisit(visit) {
    if (!visit.is_batch_blocked) {
      Batching.subscribeToVisit(
        visit,
        self.updateBatchStatus.bind(this),
        self.unsubscribeFromBatchUpdates.bind(this),
      ).then(subscription => {
        batchSupscription = subscription;
      });
    }
  }

  function updateBatchStatus(visit, batchUpdate) {
    const newStatus = batchUpdate ? batchUpdate.message || batchUpdate.status : 'idle';
    if (self.order.batch.status !== newStatus) {
      $scope.$evalAsync(() => {
        self.order.batch.status = newStatus;
      });
    }
  }

  function unsubscribeFromBatchUpdates() {
    batchSupscription.unsubscribe();
    batchSupscription = null;
  }

  function removeFromBatching() {
    Batching.blockVisitFromBatching(this.order);
  }

  function hangupNotEndedPhoneCall() {
    $rootScope.hangup_by_doctor = true;
    Orders.getPhoneCalls(Orders.current.id)
      .then(({ data }) => {
        console.log('Orders.getPhoneCalls()', data);
        data.forEach(phoneCall => {
          if (phoneCall.sip_call_id && !phoneCall.ended) {
            VideoService.hangupPhoneCall(phoneCall.id)
              .then(({ data }) => {
                console.log('VideoService.hangupPhoneCall()', data);
                self.showHangupButtonForPhoneCall = false;

                if ($rootScope.session) {
                  try {
                    $rootScope.session.disconnect();
                    $rootScope.session = null;
                  } catch (err) {
                    console.log('Error disconnecting session (session.disconnect):', err);
                  }
                }
              })
              .catch(err => {
                console.log('Error hanging up phone call (VideoService.hangupPhoneCall):', err);

                if ($rootScope.session) {
                  try {
                    $rootScope.session.disconnect();
                    $rootScope.session = null;
                  } catch (err) {
                    console.log('Error disconnecting session (session.disconnect):', err);
                  }
                }
              });
          }
        });
      })
      .catch(err => {
        console.log('Error getting phone call sessions for the current order (Orders.getPhoneCalls):', err);
      });
  }

  function slvCheckedOk() {
    const { visit } = this;
    const { TASKS: VisitTasks, STATUS: VisitStatus } = Orders;

    if (!Orders.current.flags.slv) return true; // If there is SLV task required
    // Make sure video task is approved before allowing completion

    if (Orders.current.flags.slv) {
      const { status: slvTaskStatus } = Orders.current.getTask(VisitTasks.SMART_LIVE_VIDEO);

      if (slvTaskStatus === VisitStatus.OPEN || slvTaskStatus === VisitStatus.REJECTED) {
        return false;
      }
    }

    return true;
  }

  function assessingVideoCall(orderId) {
    // This code is to check if we show "Hangup and Redo Video" button
    // We skip checking if doctor has finished the videocall
    // And right now doctor is assessing the videocall
    if ($rootScope.assessingVideoCall === undefined) {
      $rootScope.assessingVideoCall = false;
    }

    if (!$rootScope.assessingVideoCall) {
      Orders.getVideoCalls(orderId)
        .then(data2 => {
          var numActiveCalls = 0;
          var activeCalls = [];
          var isAnyVideoSessionNotEnded = false;
          data2.data.forEach(videocall => {
            if (videocall.ended === null) {
              isAnyVideoSessionNotEnded = true;
              numActiveCalls++;
              activeCalls.push(videocall);
            }
          }); // IF THERE IS A VIDEO CALL IN PROGRESS (STARTED AND NOT ENDED)

          // IF THERE IS A VIDEO CALL IN PROGRESS (STARTED AND NOT ENDED)
          if (isAnyVideoSessionNotEnded) {
            var pimsParameters = localStorageService.get('pimsParameters');
            var token_refresh_interval_in_seconds;

            if (
              pimsParameters &&
              pimsParameters.pimsVisitParameters &&
              pimsParameters.pimsVisitParameters.token_refresh_interval_in_seconds
            ) {
              // NORMALLY THIS PIMS CONTENT PARAMETER SHOULD BE:  300 SECONDS (5 MINUTES)
              var param = pimsParameters.pimsVisitParameters.token_refresh_interval_in_seconds;
              if (typeof param === 'string' || param instanceof String) {
                token_refresh_interval_in_seconds = parseInt(param);
              } else {
                token_refresh_interval_in_seconds = param;
              }
            } else {
              // IF FOR SOME REASON CACHE IS MANUALLY DELETED, WE SET TOKEN REFRESH INTERVAL AS 30 SECONDS
              token_refresh_interval_in_seconds = 30;
            }

            var now = new Date().getTime();
            var timestamp = parseInt(now / 1000);
            var cached_timestamp = localStorageService.get('timestampTokenRefreshed');

            // IF THERE IS FOR THE CURRENT VISIT:
            //    1) ANY VIDEO CALL NOT ENDED
            //    2) MORE THAN 5 MINUTES OF THE LAST TOKEN REFRESH

            if (!cached_timestamp || timestamp - cached_timestamp > token_refresh_interval_in_seconds) {
              // Here we refresh/extend the user session on the database
              // For this we need we can do an API call without the query "polling=true"
              Business.getPlatformStatusToRefreshSession()
                .then(() => {
                  // Session refreshed
                  console.log('Session refreshed...');
                  localStorageService.set('timestampTokenRefreshed', timestamp);
                })
                .catch(err => {
                  console.log('Error refreshing the session: ' + JSON.stringify(err));
                });
            }
          }

          if (!$rootScope.assessingVideoCall) {
            $rootScope.numActiveCalls = numActiveCalls;
            $rootScope.activeCalls = activeCalls;
          }
        })
        .catch(err => {
          $rootScope.numActiveCalls = 0;
          $rootScope.activeCalls = [];
        })
        .finally(() => {
          // if (!queue && $rootScope.numActiveCalls === 0) {
          //   self.closeVideoDialog(Orders.current.id);
          // }
        });
    }
  }

  function getAgeAlertClass(order) {
    var className = '';

    if (!order) {
      return className;
    }

    const currentAge = $filter('age')(order.user.dob);
    const monthsUntilBirthday = 12 - (moment().diff(moment(order.user.dob), 'months') % 12);

    const addAlert = function () {
      className = 'age-alert'; // element.addClass('age-alert');
    };

    const addAlertYellow = function () {
      className = 'age-alert-yellow'; // element.addClass('age-alert-yellow');
    };

    var validacionTriggered = false;
    var serviceAgeAlertParamFound = false;
    var pimsParameters = localStorageService.get('pimsParameters');

    if (pimsParameters && pimsParameters.pimsAgeAlertCategories && pimsParameters.pimsAgeAlertCategories.length) {
      pimsParameters.pimsAgeAlertCategories.forEach(category => {
        if (category.code === order.service.code) serviceAgeAlertParamFound = true;

        if (!validacionTriggered) {
          if (
            category.code === order.service.code &&
            category.yellow.enabled &&
            !Services.validAgeAlert(category.yellow, currentAge, monthsUntilBirthday)
          ) {
            addAlertYellow();
            validacionTriggered = true;
          } else if (
            category.yellow_aditional_1 &&
            category.code === order.service.code &&
            category.yellow_aditional_1.enabled &&
            !Services.validAgeAlert(category.yellow_aditional_1, currentAge, monthsUntilBirthday)
          ) {
            addAlertYellow();
            validacionTriggered = true;
          } else if (
            category.code === order.service.code &&
            category.red.enabled &&
            !Services.validAgeAlert(category.red, currentAge, monthsUntilBirthday)
          ) {
            addAlert();
            validacionTriggered = true;
          }
        }
      });
    }

    if (
      !serviceAgeAlertParamFound &&
      pimsParameters &&
      pimsParameters.pimsAgeAlertCategories &&
      pimsParameters.pimsAgeAlertCategories.length
    ) {
      pimsParameters.pimsAgeAlertCategories.forEach(category => {
        if (!validacionTriggered) {
          if (
            category.code === 'GLOBAL' &&
            category.yellow.enabled &&
            !Services.validAgeAlert(category.yellow, currentAge, monthsUntilBirthday)
          ) {
            addAlertYellow();
            validacionTriggered = true;
          } else if (
            category.code === 'GLOBAL' &&
            category.red.enabled &&
            !Services.validAgeAlert(category.red, currentAge, monthsUntilBirthday)
          ) {
            addAlert();
            validacionTriggered = true;
          }
        }
      });
    }

    return className;
  }

  function getGenderAgeAlertClass(order) {
    var className = '';

    if (!order) {
      return className;
    }

    const currentAge = $filter('age')(order.user.dob);
    const gender = order.user.gender;
    const monthsUntilBirthday = 12 - (moment().diff(moment(order.user.dob), 'months') % 12);

    const addAlert = function () {
      className = 'age-alert'; // element.addClass('age-alert');
    };

    const addAlertYellow = function () {
      className = 'age-alert-yellow'; // element.addClass('age-alert-yellow');
    };

    var validacionTriggered = false;
    var pimsParameters = localStorageService.get('pimsParameters');

    if (
      pimsParameters &&
      pimsParameters.pimsGenderAgeAlertCategories &&
      pimsParameters.pimsGenderAgeAlertCategories.length
    ) {
      pimsParameters.pimsGenderAgeAlertCategories.forEach(category => {
        if (!validacionTriggered) {
          if (
            category.code === order.service.code &&
            category[gender].yellow.enabled &&
            !Services.validAgeAlert(category[gender].yellow, currentAge, monthsUntilBirthday)
          ) {
            addAlertYellow();
            validacionTriggered = true;
          } else if (
            category.code === order.service.code &&
            category[gender].red.enabled &&
            !Services.validAgeAlert(category[gender].red, currentAge, monthsUntilBirthday)
          ) {
            addAlert();
            validacionTriggered = true;
          }
        }
      });
    }

    return className;
  }

  function isSlvTaskDone() {
    if (Orders.current.flags.slv) {
      const { TASKS: VisitTasks, STATUS: VisitStatus } = Orders;
      const { status: slvTaskStatus } = Orders.current.getTask(VisitTasks.SMART_LIVE_VIDEO); // IF SLV TASK IS NOT DONE

      if (slvTaskStatus === VisitStatus.OPEN || slvTaskStatus === VisitStatus.REJECTED) return false;
    }

    return true;
  }

  const getMessagesThread = () => {
    if (this.isMessagesFetching) {
      return;
    }

    this.isMessagesFetching = true; // To know if the patient has unread messages
    // We refresh every 60 seconds

    Messages.getThread(Orders.current.user.id, {})
      .then(({ data }) => {
        if (data.metadata && data.metadata.num_unread_from && data.metadata.num_unread_from > 0) {
          this.hasUnreadMessages = true;
        } else {
          this.hasUnreadMessages = false;
        }
      })
      .catch(err => {
        this.hasUnreadMessages = false;
      })
      .finally(() => (this.isMessagesFetching = false));
  };

  function _startPolling() {
    if (Orders.current.flags.slv) {
      const { TASKS: VisitTasks, STATUS: VisitStatus } = Orders;
      const { status: slvTaskStatus } = Orders.current.getTask(VisitTasks.SMART_LIVE_VIDEO); // SPRINT 117
      // IF SLV TASK IS NOT DONE, THEN KEEP POLLING
      // OTHERWISE STOP POLLING (NO NEED)

      if (slvTaskStatus === VisitStatus.OPEN || slvTaskStatus === VisitStatus.REJECTED) {
        if (queuePoll) $interval.cancel(queuePoll);
        let isQueueFetching = false;
        queuePoll = $interval(() => {
          if (isQueueFetching) {
            return;
          } // This runs every 5 seconds when PIMS refreshes the visit

          isQueueFetching = true;
          Orders.getQueueVisit(Orders.current.id, true) // true for is polling
            .then(({ data }) => {
              // This code is to check if we show "Start Video" button
              $rootScope.queueEntryExists = true; // self.callTokboxModal(Orders.current.id);

              assessingVideoCall(Orders.current.id);
            })
            .catch(err => {
              $rootScope.queueEntryExists = false;
              assessingVideoCall(Orders.current.id);
            })
            .finally(() => (isQueueFetching = false));
        }, 5000);
      }
    }

    if (visitPoll) $interval.cancel(visitPoll);
    let isFetching = false;
    visitPoll = $interval(() => {
      if (isFetching) {
        return;
      }

      isFetching = true; // To refresh the visit
      // We run this every 60 seconds (before was every 5 seconds)

      Orders.getOne(Orders.current.id, true) // true for is polling
        .then(({ data }) => {
          if (Orders.current && Orders.current.id === data.id) {
            const wasViewingAsLocked = Orders.current.viewingAsLocked;
            const wasLockedByMe = Orders.current.isLockedByMe();
            Object.assign(Orders.current, data);
            if (wasViewingAsLocked) {
              const stillLockedByOther =
                data.locked_by && data.locked_by.id !== Auth.profile.id && !Orders.current.hasLockExpired();
              Orders.current.viewingAsLocked = !!stillLockedByOther;
            }
            // Issue 2 fix: If locked_by becomes null and user was viewing as locked, attempt to lock
            if (wasViewingAsLocked && !data.locked_by) {
              Orders.current.viewingAsLocked = false;
              self.lock();
            }
            // Issue 2 fix: If user was the locker but locked_by is now null, re-establish lock
            else if (wasLockedByMe && !data.locked_by) {
              self.lock();
            }
          }
        })
        .finally(() => (isFetching = false));
    }, 60000);
    if (newMessagesPoll) $interval.cancel(newMessagesPoll);

    if (self.BOD_2268_BOD_2305) {
      newMessagesPoll = $interval(getMessagesThread(), 60000);
    } else {
      let isMessagesFetching = false;
      newMessagesPoll = $interval(() => {
        if (isMessagesFetching) {
          return;
        }

        isMessagesFetching = true; // To know if the patient has unread messages
        // We refresh every 60 seconds

        Messages.getThread(Orders.current.user.id, {})
          .then(({ data }) => {
            if (data.metadata && data.metadata.num_unread_from && data.metadata.num_unread_from > 0) {
              self.hasUnreadMessages = true;
            } else {
              self.hasUnreadMessages = false;
            }
          })
          .catch(err => {
            self.hasUnreadMessages = false;
          })
          .finally(() => (isMessagesFetching = false));
      }, 60000);
    }
  }

  function showPopup() {
    const isLocked = Orders.current.isLocked();
    let title = '';
    let content = '';
    let canBeLocked = true;
    if (isLocked) {
      title = 'Visit Locked';
      content = 'Another clinician may be currently working on this visit. You may not edit anything.';
      content += '<br><br>Are you sure you want to proceed?';

      const dialogConfig = {
        template: 'app/components/modals/confirm.tpl.html',
        data: {
          title,
          content,
          buttons: {
            // hideCancel: true,
            confirm: 'Yes',
            cancel: 'Go Back',
          },
        },
      }; // For all popups mongo tracking
      // We should use 'showPopup' as action label

      ngDialog
        .openConfirm(dialogConfig)
        .then(
          success => {
            Orders.current.viewingAsLocked = true;
          },
          error => {
            // CANCEL BUTTON PRESSED
            // IF USER CLICKS ON "Go Back"
            // THEN WE SEND BACK TO VISITS' LIST

            $state.go('visits');
          },
        )
        .catch(err => {
          // APPLICATION ERROR
          var newErr = {};
          newErr.errApi = err;
        });
    } else {
      // We lock the visit
      if (!Orders.current.isLockedByMe()) {
        self.unlockAndLock();
      } else {
        self.lock();
      }
    }
  }

  self.isCbpmPatient = function (order) {
    if (!order || !order.user) return false;
    const user = order.user;
    if (user.sa_prescribed_services && user.sa_prescribed_services.cbpm_prescribed) return true;
    if (Array.isArray(user.channels) && user.channels.some(c => c.channel_id === SA_AUTH_SERVICE_MAP.CBPM)) return true;
    return false;
  };

  self.cbpmFlagClass = function (order) {
    if (order && order.user && order.user.sa_prescribed_services && order.user.sa_prescribed_services.cbpm_prescribed) {
      return 'cbpm-flag-prescribed';
    }
    return 'cbpm-flag-channel';
  };

  this.formatVisitIdNumber = function (visitId) {
    var string = visitId.toString();
    string = string.replace(/\B(?=(\d{3})+\b)/g, ' ');
    return string;
  };

  this._setupVisit = function (visit) {
    if (self.BOD_1750) {
      if (visit.default_prescriptions.length > 0) {
        self.productLabelStyle = MedicationService.getMedicationLabelStyle(
          visit.service.code,
          visit.default_prescriptions[0].code,
        );
      }
    }
    self.order = Orders.setCurrentVisit(visit, Auth.profile);
    self.orderline = self.order.order_lines[0];
    self.user = self.order.user;
    VisitBridgeStore.setActivePatient(self.user.id);
    self.currentUser = Auth.profile; // if (visit.flags.slv) {
    //   self.closeVideoDialogOtherVisits(self.order.id);
    // }

    self.serviceHasLabs = false;
    self.orderline.stages.forEach(stage => {
      if (stage.type_id === 90) {
        stage.tasks.forEach(task => {
          if (task.type === 15) {
            self.serviceHasLabs = true;
          }
        });
      }
    });

    if (self.serviceHasLabs) {
      self.tabs = [
        {
          code: 'photos',
          name: 'Photos',
        },
        {
          code: 'questions',
          name: 'Questions',
        },
        {
          code: 'refills',
          name: 'Refills',
        },
        {
          code: 'orderlabs',
          name: 'Test Kits',
        },
        {
          code: 'rxhistory',
          name: 'RX History',
        },
        {
          code: 'prescribe',
          name: 'Prescribe',
        },
        {
          code: 'mailorder',
          name: 'Auto Refills',
        },
        {
          code: 'documents',
          name: 'Documents',
        },
      ];
    } else {
      self.tabs = [
        {
          code: 'photos',
          name: 'Photos',
        },
        {
          code: 'questions',
          name: 'Questions',
        },
        {
          code: 'refills',
          name: 'Refills',
        },
        {
          code: 'rxhistory',
          name: 'RX History',
        },
        {
          code: 'prescribe',
          name: 'Prescribe',
        },
        {
          code: 'mailorder',
          name: 'Auto Refills',
        },
        {
          code: 'documents',
          name: 'Documents',
        },
      ];
    }

    showPopup();

    _startPolling();

    $timeout(function () {
      self.activeTab = 0;
      $rootScope.$broadcast('visit:loaded');
      $rootScope.$broadcast(`tab:selected:${self.tabs[self.activeTab].code}`, false);
    });
    $log.debug('Order: ', self.order);
  };

  self.load = function (id) {
    self.error = false;
    Services.getCachedPimsParameters(true)
      .then(() => {
        Orders.getOne(id || $stateParams.id)
          .then(({ data }) => {
            const promoCode = data.fee.promo_code?.code || '';
            self.promoCodeStyle = Promos.getPromoCodeStyle(promoCode);
            getAllergies(data);
            getVisitTimezone(data);
            checkHangupButtonToEndPhoneCall(data.id);

            if (data.is_batchable) {
              data = {
                ...data,
                batch: Batching.transformVisitBatchStatus(data),
              };
              subscribeToBatchableVisit(data);
            } else {
              Batching.getBatchableHistory(data).then(({ data: batchAudit }) => {
                if (batchAudit) {
                  if (batchAudit[0].is_batchable) {
                    this.batchAudit.unshift({
                      is_batchable: false,
                      reason: data.batchstatus.message,
                      timestamp: data.batchstatus.ended,
                    });
                  } else {
                    this.batchAudit = [...batchAudit.filter(audit => !audit.is_batchable)];
                  }
                }
              });
            }

            if (data.flags.slv) {
              // This runs when doctor open a visit
              // To check if there is a queue entry => we show "Start Video" button
              // To check if there are active videocalls
              if (data.queue_entry) {
                $rootScope.queueEntryExists = true;
              } else {
                $rootScope.queueEntryExists = false;
              }

              assessingVideoCall(data.id);
            } else {
              $rootScope.queueEntryExists = false;
            } //   Orders.getVideoCalls(data.id)
            //   .then((data2) => {
            //     var numActiveCalls = 0;
            //     var activeVideoCalls = [];
            //     data2.data.forEach((videocall) => {
            //       if (videocall.ended === null) {
            //         numActiveCalls++;
            //         videocall.doctor_id = videocall.doctor.id;
            //         activeVideoCalls.push(videocall);
            //       }
            //     });
            //     if (numActiveCalls > 0) {
            //       var videocall = activeVideoCalls[0];
            //       $rootScope.$broadcast('resetVideoCall', { videocall: videocall });
            //     }
            //   })
            //   .catch((err) => {
            //     console.log(err);
            //   });
            // }

            if (_.includes(Auth.profile.roles, Users.ROLES.DOCTOR.NAME)) {
              self.showNotTreatedButtonForDR = true;
              self.showNotTreatedButtonForPST = false;
            } else if (_.includes(Auth.profile.roles, Users.ROLES.BUSINESS.NAME)) {
              self.showNotTreatedButtonForDR = false;
              self.showNotTreatedButtonForPST = true;
            }

            self.showReviewButton = false;
            self.review_notes = null;
            // This is being parked as a feature due to https://23andme.atlassian.net/browse/LMNUK-273
            /*
        if (_.includes(Auth.profile.roles, Users.ROLES.SUPERVISING_DOCTOR.NAME) && (data.admin_status == 10 || data.admin_status == 9.2)) {

          self.showReviewButton = false;

          Orders.getReviewedNPVisit(data.id)
          .then((data4) => {
            self.review_notes = data4.data.review_notes;
          }).catch(err => {
            $log.error(err);
            self.review_notes = null;
          });
        } else {
          self.showReviewButton = false;
          self.review_notes = null;
        }

         */

            if (!data.flags.blocked) {
              self.getPartnerLabs(data);
            } else {
              Orders.getFlagDetails(data.id, 'blocked').then(data3 => {
                data.flagDetails = data3.data[data3.data.length - 1];
                data.flagDetails.createdLocal = new Date(data.flagDetails.created * 1000).toLocaleString();
                self.getPartnerLabs(data);
              });
            }
          })
          .catch(() => {
            self.error = true;
          });
      })
      .catch(() => {
        //
      });
  };

  self.getPartnerLabs = function (order) {
    var this2 = this;
    self.flagPartnerLabs = false;
    var pimsParameters = localStorageService.get('pimsParameters');

    if (pimsParameters && pimsParameters.getPartnerLabsResults) {
      pimsParameters.getPartnerLabsResults.forEach(category => {
        if (category.code === order.service.code) {
          self.flagPartnerLabs = true;
        }
      });
    }

    if (self.flagPartnerLabs) {
      Orders.getPartnerLabs(order.id)
        .then(({ data }) => {
          if (data.length !== 0) {
            self.partnerLabsResult = data[0];
            console.log(self.partnerLabsResult);
            console.log(data[0]);
            self.partnerLabsResult.payloadObj = JSON.parse(data[0].payload);
            console.log(self.partnerLabsResult.payloadObj);
            console.log(self.partnerLabsResult);
          }

          self._setupVisit(order);

          console.log('Hey' + self.partnerLabsResult);
        })
        .catch(err => {
          if (err.status === 404) {
            this.error = 'No data found';
          } else {
            this.error = 'Could not load data';
          }
        });
    } else {
      self._setupVisit(order);
    }
  };

  self.loadAdminCancelled = function () {
    self.adminCancelled = self.adminCancelled || [];
    const cancelledOrders = self.user.admin_cancelled;

    if (self.adminCancelled.length !== cancelledOrders.length) {
      _.each(cancelledOrders, id => {
        if (
          !_.find(self.adminCancelled, {
            id,
          })
        ) {
          Orders.getOne(id)
            .then(({ data }) => {
              self.adminCancelled.push(data);
              self.adminCancelled.sort((a, b) => b.id - a.id);
            })
            .catch(() => {});
        }
      });
    }
  };

  self.reviewNPVisit = function () {
    if (!self.review_text) {
      toastr.error('Please enter review notes.');
      return;
    }

    Orders.postReviewNPVisit(self.review_text)
      .then(data => {
        self.review_notes = self.review_text;
        toastr.success('Review notes saved successfully.');
        self.review_text = null;
      })
      .catch(err => {
        toastr.error(err.data.error_message);
        self.review_text = null;
      });
  };

  self.closeFlag = function () {
    //console.log("close the page");
    self.blocked_message = '';
  };

  self.closeReview = function () {
    //console.log("close the page");
  };

  self.flag = function (flagType) {
    const payload = {
      flags: {},
    }; // Determine if we are marking this visit as a test visit or flagging
    // this order for further inspection

    if (flagType === 'test' && self.canToggleTest()) {
      self.testing = true;
      payload.flags.test = !self.order.flags.test;
    } else if (flagType === 'blocked') {
      self.blocking = true;
      payload.flags.blocked = !self.order.flags.blocked; // payload.blocked_action = self.order.blocked_action;
    } // If we are flagging this order, make sure we have a reason

    const flagCondition = self.BOD_1780 ? flagType === 'blocked' : self.blocked_message && flagType === 'blocked';

    if (flagCondition) {
      payload.blocked_message = self.blocked_message;
      payload.blocked_action = self.blocked_action;
    }

    Orders.flag(payload)
      .then(() => {
        if (!payload.blocked_message && !self.BOD_1780) {
          Object.assign(self.order.flags, payload.flags);
          self.order.blocked_message = payload.blocked_message;
          self.blocked_message = null;
        } else {
          Orders.getFlagDetails(self.order.id, 'blocked').then(data3 => {
            Object.assign(self.order.flags, payload.flags);
            if (flagType !== 'test') {
              self.order.blocked_message = payload.blocked_message;
              self.blocked_message = null;
              self.order.flagDetails = data3.data[data3.data.length - 1];
              if (self.order.flagDetails) {
                self.order.flagDetails.createdLocal = new Date(self.order.flagDetails.created * 1000).toLocaleString();
              }
            } else {
              snackBar.openSuccessMessage(`Visit is now set to ${payload.flags.test ? 'Test' : 'Live'}`, 3000);
            }
          });
        }
      })
      .catch(err => $log.log(err))
      .finally(() => (self.testing = self.blocking = false));
  };

  self.deny = function (denial) {
    if (_.isObject(denial.reason) && denial.message && denial.message.trim()) {
      self.denying = true;
      Orders.deny(denial.message, denial.reason.id)
        .then(() => {
          Orders.current.rejection_reason = denial.reason;
          Orders.current.status = Orders.STATUS.REJECTED;
          $rootScope.$broadcast('visit:denied', denial);
        })
        .catch(err => {
          $log.error(err);
          toastr.error(err.data.message);
          console.log('Error: ', err);
        })
        .finally(() => {
          self.denying = false;
        });
    }
  };

  self.rejectVisit = () => {
    ngDialog.open({
      template: 'app/views/visits/detail/reject-dialog.tpl.html',
      // To not allow the user closes the modal without explicitely to have some action
      // select the X to close
      closeByEscape: false,
      closeByNavigation: false,
      closeByDocument: false,
      // To make possible doctor still be able to use the screen behind
      overlay: false,
      className: 'ngdialog-theme-default reject-visit',

      /* @ngInject */
      controller: [
        '$scope',
        'reasons',
        ($scope, reasons) => {
          $scope.$on('ngDialog.opened', function (e, $dialog) {
            $('.ngdialog-theme-default.reject-visit').children('.ngdialog-content').draggable({
              handle: '.reject-dialog-handler',
            });
          });
          $scope.caretPosition = 0;
          $scope.initialMessage = '';
          $scope.LMNUK_1234 = self.LMNUK_1234;
          $scope.initialMessage = `Hello ${self.user.firstname},\n\n`;
          $scope.caretPosition = $scope.initialMessage.indexOf(
            '\n',
            $scope.initialMessage.indexOf('\n', $scope.initialMessage.indexOf('\n') + 1) + 1,
          );
          $scope.enableChangeCaretCheck = (initial, current) => {
            return initial === current;
          };
          $scope.denial = {};
          $scope.denial.message = `Hello ${self.user.firstname},\n\n`;

          $scope.reasons = reasons.data.data; // gimme those damn reasons

          $scope.deny = denial => {
            if (_.isObject(denial.reason) && denial.message && denial.message.trim()) {
              $scope.closeThisDialog(denial);
            } else {
              $scope.error = true;
            }
          };
        },
      ],
      resolve: {
        reasons: () => Orders.getRejectionReasons(),
      },
      preCloseCallback: self.deny,
    });
  };

  self.denybyPST = function (denial) {
    if (_.isObject(denial.reason) && denial.message && denial.message.trim()) {
      self.denying = true;
      Orders.denyByPST(denial.message, denial.reason.id)
        .then(() => {
          Orders.current.rejection_reason = denial.reason;
          Orders.current.status = Orders.STATUS.REJECTED;
          $rootScope.$broadcast('visit:denied', denial);
        })
        .catch(err => {
          $log.error(err);
          toastr.error(err.data.message);
          console.log('Error: ', err);
        })
        .finally(() => {
          self.denying = false;
        });
    }
  };

  self.rejectVisitByPST = () => {
    ngDialog.open({
      template: 'app/views/visits/detail/reject-pst-dialog.tpl.html',
      // To not allow the user closes the modal without explicitely to have some action
      // select the X to close
      closeByEscape: false,
      closeByNavigation: false,
      closeByDocument: false,
      // To make possible doctor still be able to use the screen behind
      overlay: false,
      className: 'ngdialog-theme-default reject-visit',

      /* @ngInject */
      controller: [
        '$scope',
        'reasons',
        ($scope, reasons) => {
          $scope.$on('ngDialog.opened', function (e, $dialog) {
            $('.ngdialog-theme-default.reject-visit').children('.ngdialog-content').draggable({
              handle: '.reject-dialog-handler',
            });
          });
          $scope.reasons = reasons.data.data; // gimme those damn reasons

          $scope.denybyPST = denial => {
            if (_.isObject(denial.reason) && denial.message && denial.message.trim()) {
              $scope.closeThisDialog(denial);
            } else {
              $scope.error = true;
            }
          };
        },
      ],
      resolve: {
        reasons: () => Orders.getRejectionReasons('pst'),
      },
      preCloseCallback: self.denybyPST,
    });
  };

  self.lock = (polling = false) => {
    Orders.lock(Orders.current.id, polling)
      .then(({ data }) => {
        if (!lockPollInterval) {
          Orders.current.locked_by = {
            id: Auth.profile.id,
            firstname: Auth.profile.firstname,
            lastname: Auth.profile.lastname,
          };
          lockPollInterval = $interval(() => {
            self.lock(true);
          }, Orders.current.getLockInterval());
        }
        Orders.current.locked_at = new Date(data.locked_at);
      })
      .catch(({ data }) => {
        if (lockPollInterval) {
          $interval.cancel(lockPollInterval);
          lockPollInterval = null;
        }
        if (Orders.current.isLockedByMe()) {
          if (data.order.locked_by) {
            Orders.current.locked_by = {
              ...data.order.locked_by,
            };
            Orders.current.locked_at = new Date(data.order.locked_at);
          }
          // Stop lock polling when forced out
          if (lockPollInterval) {
            $interval.cancel(lockPollInterval);
            lockPollInterval = null;
          }
          showPopup();
          //TODO: ideally BE should send the firstname and lastname too.
          toastr.error(
            `${Orders.current.locked_by.firstname} ${Orders.current.locked_by.lastname} has forced unlocked this visit.`,
          );
        } else {
          toastr.error(
            `${Orders.current.locked_by.firstname} ${Orders.current.locked_by.lastname} is still locking this visit.`,
          );
        }
      });
  };

  self.canToggleTest = () => {
    const allowedRoles = [Users.ROLES.SUPER.NAME, Users.ROLES.QA_USER.NAME];
    const currentClinicianRoles = Object.values(LoggedInUserStore.user().roles);
    return allowedRoles.some(el => currentClinicianRoles.includes(el));
  };

  self.unlock = (cb = angular.noop, keepAlive = false) => {
    _stopTimers(); // If visit is NOT locked by another user, then we unlock it

    if (!Orders.current.isLocked() && !keepAlive) {
      return Orders.unlock()
        .then(() => cb())
        .catch(() => toastr.error('Failed to unlock visit. Please try again.'));
    } else if (!Orders.current.isLocked() && keepAlive) {
      return Orders.unlockWithKeepAlive();
    } else {
      cb();
    }
  };

  self.unlockAndLock = () => {
    self.unlocking = true;
    Orders.unlock()
      .then(() => self.lock())
      .catch(() => toastr.error('Failed to unlock this visit. Please try again.'))
      .finally(() => {
        self.unlocking = false;
      });
  };

  self.openUnlockDialog = () => {
    if (!self.order.locked_by) {
      return;
    }

    const unlockDialogConfig = {
      template: 'app/components/modals/confirm.tpl.html',
      data: {
        title: 'Are You Sure?',
        content: `By unlocking this visit, you will assume control of this visit from Dr. ${self.order.locked_by.lastname} and disallow other doctors from making modifications.`,
        buttons: {
          confirm: 'Yes, unlock this visit',
        },
      },
    };
    ngDialog.openConfirm(unlockDialogConfig).then(() => {
      self.unlockAndLock();
    });
  };

  self.loadNewVisit = function (id) {
    self.visitId = id;
    RefillResponsesStoreStore.setVisitId(id);
    if (self.order?.id !== id) {
      // PIMS - Remove automatic unlocking
      // https://app.asana.com/0/333364685358613/1188754778297449
      _stopTimers();

      self.unlock(() => {
        $state.go(
          'visitDetail',
          {
            id,
          },
          {
            notify: false,
            reload: true,
          },
        );
        $rootScope.pageTitle = `Visit ${id}`;
        self.load(id);
      });
    }
  };
  /*
      self.selectTab = (tab) => {
        //self.activeTab = self.tabs.indexOf(tab);
        let obj = self.tabs.find(x => x.code === tab.code);
        self.activeTab = self.tabs.indexOf(obj);
        $scope.$broadcast(`tab:selected:${tab.code}`, true);
      };
  */

  $scope.$on('tab:changed', (event, tabCode) => {
    self.paramTab = tabCode;
    const tab = self.tabs.find(tab => tab.code === tabCode);
    const index = self.tabs.findIndex(tab => tab.code === tabCode);
    self.selectTab(tab, index, event);
  });

  self.selectTab = (tab, index, event) => {
    // IF USER CLICKS ON TAB
    // REFRESH ORDER DATA AND SHOW DATA ON TAB
    if (event && event.type === 'click') {
      self.activeTab = index;
      $state.go(
        $state.current,
        { id: self.visitId, tab: tab.code },
        { notify: false, reload: false, location: 'replace' },
      );
      $scope.$broadcast(`tab:selected:${tab.code}`, true); // IF USER OPENS A VISIT
      // JUST SHOW DATA ON TAB
    } else {
      if (self.paramTab) {
        self.activeTab = self.tabs.findIndex(tab => tab.code === self.paramTab);
        tab = self.tabs.find(tab => tab.code === self.paramTab);
        $state.go(
          $state.current,
          { id: self.visitId, tab: tab.code },
          { notify: false, reload: false, location: 'replace' },
        );
      }
      $scope.$broadcast(`tab:selected:${tab.code}`, false);
    }
  };

  //TODO: Harold
  self.openBMIHistory = function () {
    // ngDialog.open({
    //   template: '<bmi-history data = testObj></bmi-history>',
    //   plain: true,
    //   className: 'ngdialog-theme-default',
    // });
    ngDialog.open({
      templateUrl: 'app/components/bmi-history/bmi-history.html',

      showClose: true,
      closeByEscape: true,
      closeByNavigation: true,
      closeByDocument: true,
      className: 'ngdialog-theme-default bmi-history-dialog',
      controller: 'BmiHistoryController',
      controllerAs: 'vm',
      data: {
        bmiData: self.mockBMI,
      },
    });
  };

  function _stopTimers() {
    if (newMessagesPoll) $interval.cancel(newMessagesPoll);
    if (visitPoll) $interval.cancel(visitPoll);
    if (queuePoll) $interval.cancel(queuePoll);
    if (sessionTimer) $timeout.cancel(sessionTimer);
    if (finalTimer) $timeout.cancel(finalTimer);
    if (batchSupscription) batchSupscription.unsubscribe();
    if (lockPollInterval) {
      $interval.cancel(lockPollInterval);
      lockPollInterval = null;
    }
    sessionTimer = null;
    finalTimer = null;
    batchSupscription = null;
  } // Hijack state changes to gracefully load in new visit

  const stateChangeListener = $rootScope.$on('$stateChangeStart', (event, toState, toParams) => {
    if (toState.name === 'visitDetail') {
      event.preventDefault();
      self.loadNewVisit(toParams.id);
    }
  });
  $scope.$on('$destroy', () => {
    stateChangeListener();
    ngDialog.closeAll();
    if (Auth.isLoggedIn()) {
      // PIMS - Remove automatic unlocking
      // https://app.asana.com/0/333364685358613/1188754778297449

      self.unlock(() => {
        Orders.current = null;
      }, true);
    }
    _stopTimers();
  });

  window.addEventListener('beforeunload', event => {
    // NOTE: Urgent fix, find and wrap in the correct feature flag post release...
    // For now added a new one which is negated to fix prod issue...
    if (!this.BOD_2205) {
      event.preventDefault();
      event.returnValue = false;
    }
    // event.returnValue = false;
    // PIMS - Remove automatic unlocking
    // https://app.asana.com/0/333364685358613/1188754778297449
    // _stopTimers();
    self.unlock(undefined, true);
  });

  self.load();
}

angular.module('pims').controller('VisitController', VisitController);
